export default "__VITE_ASSET__xMR5JS2A__"